import React from "react";
import { IconContext } from 'react-icons/lib';

export default function ResizeRecolor({ children }) {
    return (
        <>
            <IconContext.Provider value={{ color: "black", size: "4em", style: { verticalAlign: 'middle' }}}>
                {children}
            </IconContext.Provider>
        </>
    );
}